import {FormioBase} from "./formiobase";

export class Phone extends FormioBase {
  public inputType = "phoneNumber";
  public title = "Phone";
  public icon = "fa fa-phone-square";
  public schema: any = {
    title: "phone",
    components: [{
      input: true,
      tableView: true,
      inputMask: "(999) 999-9999",
      label: "Phone",
      key: "phonenumberField1",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      protected: false,
      inputType: "phoneNumber",
      unique: false,
      persistent: true,
      defaultValue: "",
      clearOnHide: true,
      notvisible: false,
      validate: {
        required: false,
      },
      type: "phoneNumber",

      tags: [],
      description: "",
      tooltip: "",
      customClass: "ds-phone",
    }],
  };
}
